import { ComponentPropsWithoutRef } from 'react';
import { Button } from '@givebutter/primitives/button';
import { faCircleXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { twMerge } from 'tailwind-merge';

interface FilterDeleteButtonProps
    extends Omit<ComponentPropsWithoutRef<'button'>, 'children' | 'color'> {}

const FilterDeleteButton = (props: FilterDeleteButtonProps) => {
    const { className = '', ...rest } = props;
    return (
        <Button
            variant="none"
            color="neutral"
            size="sm"
            className={twMerge('text-gray-500 hover:text-red-400', className)}
            {...rest}
        >
            <FontAwesomeIcon icon={faCircleXmark} />
        </Button>
    );
};

export { FilterDeleteButton };
